import { makeStyles } from "../../providers/makeStyles";

export const useFilteredOrganisationsStyles = makeStyles(theme => ({
    firstLetter: {
        padding: theme.spacing(2,0,1)
    }
}));
